import Pagy from './pagy.mjs';

window.Pagy = Pagy; // to allow SRJ to update current page pagination
window.addEventListener('DOMContentLoaded', Pagy.init);
